import { createI18n } from 'vue-i18n';
import ko from './locales/ko.js';
import en from './locales/en.js';
import vi from './locales/vi.js';
import zh from './locales/zh.js';
import ja from './locales/ja.js';
import mn from './locales/mn.js';

import ko_server from "./serverLocales/ko.js";
import en_server from "./serverLocales/en.js";
import vi_server from "./serverLocales/vi.js";
import zh_server from "./serverLocales/zh.js";
import ja_server from "./serverLocales/ja.js";
import mn_server from "./serverLocales/mn.js";

// 서버 로케일 메시지를 클라이언트 로케일에 병합하는 함수
function mergeServerMessages(clientLocale, serverLocale) {
  if (!clientLocale.common) {
    clientLocale.common = {};
  }
  
  if (!clientLocale.common.messages && serverLocale?.common?.messages) {
    clientLocale.common.messages = { ...serverLocale.common.messages };
  } else if (serverLocale?.common?.messages) {
    clientLocale.common.messages = {
      ...clientLocale.common.messages,
      ...serverLocale.common.messages
    };
  }
  
  if (!clientLocale.auth && serverLocale?.auth) {
    clientLocale.auth = { ...serverLocale.auth };
  } else if (serverLocale?.auth) {
    clientLocale.auth = {
      ...clientLocale.auth,
      ...serverLocale.auth
    };
  }
  
  return clientLocale;
}

const i18n = createI18n({
  legacy: false, // Vue 3와 함께 사용하기 위해 Composition API 모드 활성화
  locale: "ko", // 기본 언어 설정
  fallbackLocale: "en", // 번역이 누락된 경우 대체할 언어
  messages: {
    ko: mergeServerMessages(ko, ko_server),
    en: mergeServerMessages(en, en_server),
    vi: mergeServerMessages(vi, vi_server),
    zh: mergeServerMessages(zh, zh_server),
    ja: mergeServerMessages(ja, ja_server),
    mn: mergeServerMessages(mn, mn_server),
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});

export default i18n; 